import React, { useState, useEffect, useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { sendLoadingPostRequest } from "../../request/request";
import { Dictionary } from "../../types/Dictionary";
import {
  TextField,
  ThemeProvider,
  Autocomplete,
  createTheme,
  styled,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import localizedFormat from "dayjs/plugin/localizedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/pl";

dayjs.extend(isSameOrAfter);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.locale("pl");

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  height: 50,
}));

const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          display: "none",
        },
      },
    },
  },
});

const Calendar = (props: any) => {
  const parsedValue = dayjs(props.value);
  const hasValidValue = parsedValue.isValid();

  const handleChange = (date: any) => {
    if (props.onChange) {
      props.onChange(date ? dayjs(date).format("YYYY-MM-DD") : null);
    }
  };

  const localeText = {
    ...(props.localeText ?? {}),
    fieldYearPlaceholder: () => "RRRR",
  };

  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pl">
        <DatePicker
          sx={{
            width: "100%",
            ".MuiPickersSectionList-section": {
              color: hasValidValue
                ? "rgba(0, 0, 0, 0.87)"
                : "rgba(0, 0, 0, 0.47)",
            },
          }}
          {...props}
          localeText={localeText}
          onChange={handleChange}
          openTo="year"
          views={["year", "month", "day"]}
          slotProps={{
            textField: {
              // @ts-ignore
              readOnly: false, // this is making input field as readonly but ts throwing error
              placeholder: "RRRR-MM-DD",
              InputProps: {
                value: hasValidValue ? parsedValue.format(props.format) : "",
              },
            },
          }}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export { Calendar };
